import { useEffect, useState } from 'react';
import { ListLayoutVariant } from 'core/flow/entities';
import { AnimationTypes } from './types';
import { AnswerListItemStyled, AnswerListStyled } from './styled';

type AnimatedListProps<T> = {
  list: Array<T>;
  className?: string;
  animationVariant: AnimationTypes;
  layoutVariant?: ListLayoutVariant;
  renderContentItem: (props: T) => JSX.Element;
};

export const AnimatedList = <T,>({
  list,
  renderContentItem,
  animationVariant = AnimationTypes.NONE,
  layoutVariant = ListLayoutVariant.COLUMN,
  className,
}: AnimatedListProps<T>) => {
  const [isAnimate, setIsAnimate] = useState(false);

  useEffect(() => {
    setIsAnimate(true);
  }, []);

  return (
    <AnswerListStyled layoutVariant={layoutVariant} className={className}>
      {list.map((item, i) => {
        return (
          <AnswerListItemStyled
            key={i}
            index={i}
            animationVariant={animationVariant}
            isAnimate={isAnimate}
          >
            {renderContentItem(item)}
          </AnswerListItemStyled>
        );
      })}
    </AnswerListStyled>
  );
};
